import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon, eyeIcon } from '../../../config/variables';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { IOrder } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import { useTranslation } from 'react-i18next';
import TableSkeleton from '../../../components/loaders/TableSkeleton';

const OrdersTableContainer = ({ tableHeaders, data, noDataMessage, apiDataLoading, lessColumns }: ITableContainerProps<IOrder[]>) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const hasEditPermission = hasPermission(['orders.edit']);

  if (apiDataLoading) return <TableSkeleton columns={8} withoutButton withoutHeader />;

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map(
          (header, index) =>
            header && (
              <span className={`head ${header.customClass}`} key={index}>
                {header.label}
              </span>
            )
        )}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => {
              const isProccessing = item?.status == "Proccessing" || item?.status == "Confirmed";
              return (
                <div
                  className={`item has_logo ${hasEditPermission && 'clickable'} orders`}
                  key={index}
                  onClick={(e) => {
                    hasEditPermission && navigateRoute(e, `/orders/order-details/${item.id}`, navigate);
                  }}
                >
                  <div className="column">{item?.id || '-'}</div>
                  <div className="column">
                    <div className="capitalize">{item?.vehicle?.variant?.vehicle_model?.name || '-'}</div>
                  </div>
                  <div className="column">{item?.vehicle?.chassis || '-'}</div>
                  <div className="column">
                    <div className="capitalize">{item?.user?.first_name || item?.user?.last_name ? `${item?.user?.first_name || ''} ${item?.user?.last_name || ''}` : '-'}</div>
                  </div>
                  <div className="column">{item?.order_value ? Number(item?.order_value)?.toLocaleString('en-US') : '-'}</div>
                  <div className="column">{item?.date || '-'}</div>
                  <div className="column">{item?.customer_refused_vehicle ? t('customer_refused_vehicle') : isProccessing ? (!item?.paid_amount ? t("awaiting-payment") : (item?.order_value - item?.paid_amount)) ? t("partially-paid") : t("fully-paid") : item?.status || '-'}</div>
                  {hasEditPermission && (
                    <div className="column actions actions_col">
                      <div
                        className="action_btn edit"
                        onClick={(e) => {
                          navigateRoute(e, `/orders/order-details/${item.id}`, navigate);
                        }}
                      >
                        {eyeIcon}
                      </div>
                      {item?.status !== 'Paid And Finished' && item?.status !== 'Abandoned Cart' && item?.status !== 'Cancelled' && (
                        <div
                          className="action_btn edit"
                          onClick={(e) => {
                            navigateRoute(e, `/orders/create-order/${item.id}`, navigate);
                          }}
                        >
                          {editIcon}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default OrdersTableContainer;
